import { createAction } from '@reduxjs/toolkit';

import { normalizeMarketData } from '~shared/utils/marketSwitcherNormalizers';

export const marketSwitcherUpdate = createAction('marketSwitcherUpdate', ({
    eventIdsFromStore,
    marketSwitcherSelections,
    marketIds,
    selectedMarketName,
    selectionSchema,
    dataPointersId,
}) => {
    const {
        markets,
        marketsEvents,
        selections,
        dataPointers,
    } = normalizeMarketData(
        eventIdsFromStore,
        marketSwitcherSelections,
        marketIds,
        selectedMarketName,
        selectionSchema,
        dataPointersId,
    );

    return {
        payload: {
            markets,
            marketsEvents,
            selections,
            dataPointers,
        },
    };
});
